import { createUseStyles } from "react-jss";

const IFrameViewerStyles = createUseStyles({
    docContent: {
        background: "#F3F3F3",
        height: "100%",
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "center",
        alignSelf: "center",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        margin: "20px 20px 20px 20px",
        '& div > div > div.iSVAnT': {
            background: 'white !important'
        },
    },
    description: {
        fontSize: "18px",
        marginBottom: "20px",
        marginTop: "10px",
        color: "#333",
        textAlign: "center",
        fontWeight: "600",
        alignSelf: "center",
        width: "100%"
    },
    spinner: {
        alignSelf: "center",
        display: "flex",
        flex: 1,
        color: "#74767c"
    },
    video: {
        width: "100%",
        minHeight: "500px",
        alignSelf: "center",
    },
})

export default IFrameViewerStyles;
